/** @jsxImportSource theme-ui */
import { jsx } from 'theme-ui'
import { Flex, Heading } from '@theme-ui/components'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import BlueLine from './BlueLine'
import { RegionalLink } from '../atoms';
import { getLinkId } from '@greythr/shared-utils/common';

const ModuleImage = ({ module, align }) => {
  const px = align === 'left' ? '15px' : 0
  return (
    <img
      sx={{
        width: ['100%', '20%'],
        minWidth: '300px',
        flex: 1,
        mt: 2,
        px,
        pb: 3,
      }}
      src={module.image}
      alt={module.alt}
      title={module.imgTitle}
    />
  )
}

const ModuleDescription = ({ module, align, region }) => {
  const pr = align === 'left' ? [0, 0, 3, 4, 6] : 0
  const learnMoreLinkId = module.title === "MOBILE APP FOR EMPLOYEES" ? "mobile_app" : module.route
  return (
    <div sx={{ pl: 2, pr, flexGrow: 1, flex: 1, minWidth: '250px' }}>
      <BlueLine />
      <Heading variant="lightHeading" as="h2">
        {module.title}
      </Heading>
      <ul sx={{ fontSize: [1, 2], listStyle: 'None', p: 0, mb: 2 }}>
        {module.points.map(point => (
          <li sx={{ py: 1 }} key={point}>
            {point}
          </li>
        ))}
      </ul>
      <RegionalLink id={getLinkId(learnMoreLinkId,region)} sx={{ color: 'linkColor', textDecoration: 'None' }} regional region={region} to={module.route}>
        LEARN MORE ➝
      </RegionalLink>
    </div>
  )
}

const ModuleSummary = props => {
  const { align, region } = props
  const flexDirection = align === 'left' ? 'row' : 'row-reverse'
  return (
    <Flex
      sx={{
        flexDirection,
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        my: [5, 5, 6],
        border: '0px solid red',
      }}
    >
      <ModuleImage {...props} />
      <ModuleDescription {...props} />
    </Flex>
  )
}

ModuleDescription.defaultProps = {
  align: 'left',
}

ModuleDescription.propTypes = {
  module: PropTypes.object.isRequired,
  align: PropTypes.string,
}

ModuleImage.defaultProps = {
  align: 'left',
}

ModuleImage.propTypes = {
  module: PropTypes.object.isRequired,
  align: PropTypes.string,
}

ModuleSummary.defaultProps = {
  align: 'left',
}

ModuleSummary.propTypes = {
  align: PropTypes.string,
}

export default ModuleSummary
